/**
 * The League crest, with the party on it waiting impatiently: the marine
 * checks his watch and shrugs, the warrior's sword droops, the wizard taps his
 * staff, the crewmate stares at you. An animated WebP rendered by
 * tools/blender/league_crest.py, shown wherever the site is waiting on
 * something (an empty page, an application in review, a wrong turn), plus as a
 * page block admins can place. Visitors who prefer reduced motion get the still.
 */

import type { ReactNode } from 'react';
import { artUrl } from '../../shared/artUrl';

export type CrestSize = 'small' | 'medium' | 'large';

const PX: Record<CrestSize, number> = { small: 160, medium: 240, large: 340 };

export default function LeagueCrest({ size = 'medium', caption }: { size?: CrestSize; caption?: ReactNode }) {
  const px = PX[size];
  return (
    <figure className="league-crest">
      <picture>
        <source srcSet={artUrl('/crest/league-crest-still.webp')} media="(prefers-reduced-motion: reduce)" />
        <img
          src={artUrl('/crest/league-crest.webp')}
          width={px}
          height={px}
          alt="The League of Ordinary Gamers crest, its party waiting impatiently"
          loading="lazy"
          decoding="async"
        />
      </picture>
      {caption && <figcaption className="league-crest-caption">{caption}</figcaption>}
    </figure>
  );
}
